/**
 * EMailBaseContent.js
 * 
 * Created on Oct 28, 2013, 09:50:11
 *
 * @author Olivier van der Pool for Ranj
 **/

import { isArray, isNull, isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import File from "./File";

export default class EMailBaseContent extends Content {
    constructor(languagePack, contentID, name, type, id, sender, recipients, ccs, subject, dateTimeOffset, priority, attachments, label) {
        isUndefined(contentID) ? contentID = null : null;
        isUndefined(name) ? name = "Email base" : null;
        isUndefined(type) ? type = "engEMailBaseContent" : null;
        isUndefined(id) ? id = null : null;
        isUndefined(sender) ? sender = null : null;
        isUndefined(recipients) ? recipients = null : null;
        isUndefined(ccs) ? ccs = null : null;
        isUndefined(subject) ? subject = null : null;
        isUndefined(dateTimeOffset) ? dateTimeOffset = 0 : null;
        isUndefined(priority) ? priority = 0 : null;
        isUndefined(attachments) ? attachments = null : null;
        isUndefined(label) ? label = null : null;
        ccs = isNull(ccs) ? [] : ccs;
        recipients = isNull(recipients) ? [] : recipients;
        attachments = isNull(attachments) ? [] : attachments;

        super(name, type, label, languagePack, contentID);

        this._dateTimeOffset = dateTimeOffset;
        this._subject = subject;
        this._sender = sender;

        this._priority = priority;
        this._id = id;
        this.opened = false;
        //initialize CCs
        this._ccIDs = [];

        for (var i = 0; i < ccs.length; i++) {
            this._addCC(ccs[i]);
        }
        //initialize recipients
        this._recipientIDs = [];
        for (i = 0; i < recipients.length; i++) {
            this._addRecipient(recipients[i]);
        }
        //initialize attachments
        this._attachments = [];
        for (i = 0; i < attachments.length; i++) {
            this._addAttachment(attachments[i]);
        }

    }

    //-----------------------------------
    //  sender
    //-----------------------------------

    setSender(value) {
        if (this._sender !== value) {
            this.setLanguagePackText(EMailBaseContent.SENDER_LABEL, value);
        }
    }

    getSender() {
        return this.getLanguagePackText(EMailBaseContent.SENDER_LABEL);
    }

    //-----------------------------------
    //  subject
    //-----------------------------------

    setSubject(value) {
        if (this._subject !== value) {
            this.setLanguagePackText(EMailBaseContent.SUBJECT_LABEL, value);
        }
    }

    getSubject() {
        return this.getLanguagePackText(EMailBaseContent.SUBJECT_LABEL);
    }

    //-----------------------------------
    //  date
    //-----------------------------------

    setDate(value) {
        if (this._date !== value) {
            this._date = value;
        }
    }

    getDate() {
        return this._date;
    }

    setDateTimeOffset(currentDate) {
        if (isUndefined(currentDate)) {
            currentDate = new Date();
        }
        this._date = new Date();
        this._date.time = currentDate.time + this.dateTimeOffset;
    }

    setOpened(value) {
        this._opened = value;
    }

    getOpened() {
        return this._opened;
    }

    setReplyDraftID(value) {
        this._replyDraftID = value;
    }

    getReplyDraftID() {
        return this._replyDraftID;
    }

    //-----------------------------------
    //  recipients
    //-----------------------------------

    getRecipients() {
        const recipients = [];

        for (let i = 0; i < this._recipientIDs.length; i++) {
            recipients.push(this.getLanguagePackText(this._recipientIDs[i]));
        }
        return recipients;
    }

    _addRecipient(value) {
        do {
            var uniqueID = true;
            var id = `recipient${Math.floor(Math.random() * 99999999999)}`;
            for (let i = 0; i < this._recipientIDs.length; i++) {
                if (id === this._recipientIDs[i]) uniqueID = false;
            }
        } while (!uniqueID);

        this.setLanguagePackText(id, value);
        this._recipientIDs.push(id);
    }

    _removeRecipient(value) {
        for (let i = 0; i < this._recipientIDs.length; i++) {
            if (this.getLanguagePackText(this._recipientIDs[i]) === value) {
                this.removeLanguagePackText(this._recipientIDs[i]);
                this._recipientIDs.splice(i, 1);
            }
        }
    }

    _removeAllRecipients() {
        for (let i = 0; i < this._recipientIDs.length; i++) {
            this.removeLanguagePackText(this._recipientIDs[i]);
        };
        this._recipientIDs.length = 0;
    }

    setId(value) {
        this._id = value;
    }

    getId() {
        return this._id;
    }

    //-----------------------------------
    //  ccs
    //-----------------------------------

    getCCs() {
        const ccs = [];
        for (let i = 0; i < this._ccIDs.length; i++) {
            ccs.push(this.getLanguagePackText(this._ccIDs[i]));
        }
        return ccs;
    }

    setCcIDs(value) {
        this._ccIDs = value;
    }

    getCcIDs() {
        return this._ccIDs;
    }

    _addCC(value) {
        do {
            var uniqueID = true;
            var id = `cc${Math.floor(Math.random() * 99999999999)}`;
            for (let i = 0; i < this._ccIDs.length; i++) {
                if (id === this._ccIDs[i]) uniqueID = false;
            }
        } while (!uniqueID);

        this.setLanguagePackText(id, value);
        this._ccIDs.push(id);
    }

    _removeCC(value) {
        for (let i = 0; i < this._ccIDs.length; i++) {
            if (this.getLanguagePackText(this._ccIDs[i]) === value) {
                this.removeLanguagePackText(this._ccID[i]);
                this._ccIDs.splice(this._recipientIDs.indexOf(this._ccIDs[i]), 1);
            }
        }
    }

    _removeAllCCs() {
        for (let i = 0; i < this._ccIDs.length; i++) {
            this.removeLanguagePackText(this._ccIDs[i]);
        };
    }

    setRecipientIDs(value) {
        this._recipientIDs = value;
    }

    getRecipientIDs(value) {
        return this._recipientIDs;
    }

    setPriority(value) {
        return this._priority = value;
    }

    getPriority() {
        return this._priority;
    }

    getDateTimeOffset() {
        return this._dateTimeOffset;
    }

    setDateTimeOffset(value) {
        return this._dateTimeOffset = value;
    }

    //-----------------------------------
    //  attachments
    //-----------------------------------

    getAttachments() {
        return this._attachments;
    }

    setAttachments(value) {
        this._attachments = value;
    }

    _addAttachment(value) {
        this._attachments.push(value);
    }

    _removeAttachment(value) {
        const index = this._attachments.indexOf(value);
        if (index > -1) {
            this._attachments.splice(index, 1);
        }
    }

    _removeAllAttachment() {
        for (let i = 0; i < this._attachments.length; i++) {
            this._attachments[i].remove();
        };
        this._attachments.length = 0;
    }

    exportText(csv) {
        console.warn("[EMailBaseContent]", "the method exportText is not yet implemented!");
    }

    //-----------------------------------
    //  public functions
    //-----------------------------------

    setPropertiesFromObject(object) {
        if (!isNull(object.attachments) && isArray(object.attachments)) {
            for (let i = 0; i < object.attachments.length; i++) {
                const attachmentObj = object.attachments[i];
                const file = new File(this._languagePack);
                file.setPropertiesFromObject(attachmentObj);
                this._addAttachment(file);
            }
        }
        delete object.attachments;

        if (!isNull(object.recipientIDs) && isArray(object.recipientIDs)) {
            this._recipientIDs = object.recipientIDs;
            delete object.recipientIDs;
        }
        if (!isNull(object.ccIDs) && isArray(object.ccIDs)) {
            this._ccIDs = object.ccIDs;
            delete object.ccIDs;
        }
        if (!isNull(object.date)) {
            this._date = new Date(object.date);
            delete object.date;
        }
        super.setPropertiesFromObject(object);
    }

    convertToObject() {
        const object = this.getObject([]);
        return object;
    }

    getObject(propertyNames) {
        propertyNames.addAll(["id", "priority", "opened", "dateTimeOffset"]);
        const object = super.getObject(propertyNames);
        if (!isNull(this._date)) {
            object.date = this._date.valueOf();
        }

        object.attachments = [];
        for (let i = 0; i < this._attachments.length; i++) {
            object.attachments.push(this._attachments[i].convertToObject());
        }
        object.recipientIDs = this._recipientIDs;
        object.ccIDs = this._ccIDs;
        return object;
    }
}

EMailBaseContent.TYPE = "engEMailBaseContent";
EMailBaseContent.SENDER_LABEL = "sender";
EMailBaseContent.SUBJECT_LABEL = "subject";
EMailBaseContent.DATE_LABEL = "date";